import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Statement from "./pages/Statement";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/statement" element={<Statement />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
